import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import FileProgress from "../FileProgress";
import { useUploadManager } from "./context";
const UploadFileProgress = () => {
    const { state: { file, estimatedEndTimestamp, totalBytes, currentBytes }, } = useUploadManager();
    return (_jsx(FileProgress, { percentComplete: Math.round(((currentBytes || 0) / totalBytes) * 100), filename: file === null || file === void 0 ? void 0 : file.name, estimatedEndTimestamp: estimatedEndTimestamp, totalBytes: totalBytes }));
};
export default UploadFileProgress;
